<template>
  <div class="content">
    <b-modal id="modal" title="Direct Message: Eliza - Support Technician" ref="modal" size="lg" scrollable hide-footer>
      <div class="row mb-3">
        <div class="col">
          <input :disabled="waiting" type="text" ref="fldMessage" class="form-control" placeholder="Type your response here..." v-model="message" v-on:keyup.enter="chat">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <b-alert show variant="warning" v-if="waiting">Eliza is typing a message...</b-alert>
          <b-alert show v-for="logEntry in reverseLog" :variant="logEntry.bot ? 'info' : 'success'" :key="logEntry.index">
            {{ (logEntry.bot ? 'Eliza: ' : fullName + ': ') + logEntry.message }}
          </b-alert>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import elizaBot from '../../other/eliza-bot'

  export default {
    name: "generic-eliza",
    props: {
    },
    data() {
      return {
        message: null,
        log: [ ],
        eliza: null,
        fullName: window.appState.userFullName,
        maxWait: 5000,
        waiting: false
      };
    },
    computed: {
      reverseLog() {
        let output = [ ];
        for (let logIndex = this.log.length - 1; logIndex >= 0; logIndex--) {
          output.push(this.log[logIndex]);
        }
        return output;
      }
    },
    methods: {
      init() {
        this.eliza = new elizaBot();
        let self = this;
        this.log = [];
        this.message = '';
        let newEntry = { bot: true, message: this.eliza.getInitial(), index: this.log.length };
        this.waiting = true;
        setTimeout(() => { 
          self.log.push(newEntry);
          this.waiting = false;
          setTimeout(() => {
            self.$refs.fldMessage.focus();
          }, 100);
        }, this.getWaitTime());
      },
      show(event) {
        appHelpers.audit.logEntityAction('Initiated', 'Eliza');
        let promise = this.$refs.modal.show();
        this.init();
        return promise;
      },
      chat() {
        if (this.message) {
          this.log.push({ bot: false, message: this.message, index: this.log.length });
          this.message = '';
          let newEntry = { };
          let quitFlag = false;
          this.waiting = true;
          this.eliza.getResponse(this.message).then((response) => {
            let self = this;
            if (response.reply) {
              newEntry = { bot: true, message: response.reply, index: this.log.length };
            }
            if (response.final) {
              newEntry = { bot: true, message: response.final, index: this.log.length };
              quitFlag = true;
            }
            if (newEntry) {
              setTimeout(() => { 
                self.log.push(newEntry);
                if (quitFlag) {
                  setTimeout(() => { self.$refs.modal.hide()}, 1000);
                }
                this.waiting = false;
                Vue.nextTick(() => { self.$refs.fldMessage.focus(); });
              }, this.getWaitTime());
            }
          });
        };
      },
      getWaitTime() {
        return Math.floor(Math.random() * Math.floor(this.maxWait));
      }
    }
  };
</script>